import React from "react";
import UNCapacityBuildingContent from "../../components/layouts/misi-internasional/UNCapacityBuildingContent";

const UNCapacityBuilding: React.FC = () => {
  return (
    <div>
      <UNCapacityBuildingContent />
    </div>
  );
};

export default UNCapacityBuilding;
